import React from 'react';

interface State { hasError: boolean; error?: Error }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-pink-50 p-8">
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-md text-center">
            <div className="text-5xl mb-4">😿</div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">Что-то пошло не так</h1>
            <p className="text-gray-600 mb-4">
              Произошла ошибка в приложении. Попробуйте перезагрузить страницу.
            </p>
            <pre className="text-xs text-left bg-gray-100 p-3 rounded-lg overflow-auto max-h-32 mb-4 text-red-600">
              {this.state.error?.message}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-lg hover:from-pink-600 hover:to-rose-600 transition"
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
